<template>
  <div class="modern-documents-page">
    <v-container class="documents-container">

      <!-- Hero Banner -->
      <div class="hero-banner">
        <v-img
          :src="require(`@/assets/banner/documents.jpg`)"
          class="hero-image"
          height="300"
        >
          <div class="hero-overlay">
            <div class="hero-content">
              <v-icon color="white" size="56" class="mb-3">mdi-file-document</v-icon>
              <h2 class="hero-title">Tamil Sangam Documents</h2>
              <p class="hero-subtitle">Official Records & Bylaws</p>
            </div>
          </div>
        </v-img>
      </div>

      <!-- Stats Cards -->
      <v-row class="stats-row">
        <v-col cols="12" sm="6" md="4">
          <div class="stat-card bylaws">
            <div class="stat-icon">
              <v-icon color="white" size="28">mdi-gavel</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-value">{{ getTotalFiles() }}</div>
              <div class="stat-label">Documents</div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div class="stat-card official">
            <div class="stat-icon">
              <v-icon color="white" size="28">mdi-shield-check</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-value">Official</div>
              <div class="stat-label">Verified</div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div class="stat-card access">
            <div class="stat-icon">
              <v-icon color="white" size="28">mdi-download</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-value">Public</div>
              <div class="stat-label">Access</div>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Documents Section -->
      <div class="documents-section">
        <v-row>
          <!-- Tree View Column -->
          <v-col cols="12" md="4">
            <div class="tree-card">
              <div class="tree-header">
                <v-icon color="#667eea" class="mr-2">mdi-folder-open</v-icon>
                <h3 class="tree-title">Document Library</h3>
              </div>
              <div class="tree-content">
                <v-treeview
                  v-model="selection"
                  :open="open"
                  :items="items"
                  selectable
                  return-object
                  open-all
                  item-key="name"
                  class="modern-treeview"
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file" :color="open ? '#667eea' : '#94a3b8'">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else color="#f44336">
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                </v-treeview>
              </div>
            </div>
          </v-col>

          <!-- Preview Column -->
          <v-col cols="12" md="8">
            <div class="preview-card">
              <div class="preview-header">
                <v-icon color="#667eea" class="mr-2">mdi-file-eye</v-icon>
                <h3 class="preview-title">Document Preview</h3>
              </div>
              <div class="preview-content">
                <div v-if="selection.length === 0" class="empty-state">
                  <v-icon color="#94a3b8" size="80">mdi-file-document-outline</v-icon>
                  <h3 class="empty-title">No Document Selected</h3>
                  <p class="empty-text">Select a document from the library to view details</p>
                </div>
                <div v-else class="selected-documents">
                  <div
                    v-for="node in selection"
                    :key="node.name"
                    class="document-item"
                  >
                    <div class="document-icon">
                      <v-icon color="white" size="32">mdi-file-pdf</v-icon>
                    </div>
                    <div class="document-info">
                      <h4 class="document-name">{{ node.name }}</h4>
                      <div v-html="getDetails(node.path)" class="document-link"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    open: ['AcademicYear'],
    files: {
      pdf: 'mdi-file-pdf'
    },
    selection: [],
    items: [
      {
        name: 'File Name',
        children: [
          { name: 'ByLaw', file: 'pdf', path: 'https://cltts-docs.s3.amazonaws.com/ByLaw/TS_ByLaw_2022.pdf' }
        ]
      }
    ],
  }),
  methods: {
    getDetails(detail) {
      var html = detail
      if(detail.startsWith('http')) {
        html = detail.replace(html, '<a href="' + html + '" target="_blank" class="document-download-link">' + '<v-icon small class="mr-1">mdi-download</v-icon> Download Document' + '</a>')
        return html
      }
      return html
    },
    getTotalFiles() {
      let count = 0
      this.items.forEach(item => {
        if (item.children) {
          count += item.children.length
        }
      })
      return count
    }
  }
}
</script>


<style lang="scss" scoped>
.modern-documents-page {
  background: linear-gradient(135deg, #fdfeff 0%, #f0f4f8 50%, #e8f0f7 100%);
  min-height: 100vh;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
      radial-gradient(circle at 20% 30%, rgba(102, 126, 234, 0.08) 0%, transparent 50%),
      radial-gradient(circle at 80% 70%, rgba(118, 75, 162, 0.08) 0%, transparent 50%);
    pointer-events: none;
  }
}

.documents-container {
  max-width: 100%;
  padding: 24px 16px;
  position: relative;
  z-index: 1;
}

/* Page Header */
.page-header {
  text-align: center;
  margin-bottom: 24px;
  position: relative;
  padding: 18px 20px;
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 252, 255, 0.9) 50%,
    rgba(240, 248, 255, 0.95) 100%);
  border-radius: 20px;
  box-shadow:
    0 8px 24px rgba(102, 126, 234, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.6) 50%,
      transparent 100%);
    animation: shine 3s infinite;
  }
}

@keyframes shine {
  0% { left: -100%; }
  50%, 100% { left: 100%; }
}

.header-icon-wrapper {
  width: 48px;
  height: 48px;
  margin: 0 auto 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    0 8px 20px rgba(102, 126, 234, 0.3),
    0 2px 8px rgba(118, 75, 162, 0.2);
}

.page-title {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.page-subtitle {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

/* Hero Banner */
.hero-banner {
  margin-bottom: 24px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow:
    0 12px 32px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 1);
}

.hero-image {
  border-radius: 24px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg,
    rgba(102, 126, 234, 0.85) 0%,
    rgba(118, 75, 162, 0.85) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content {
  text-align: center;
  color: white;
  padding: 20px;
}

.hero-title {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 8px;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-size: 16px;
  font-weight: 500;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

/* Stats Cards */
.stats-row {
  margin-bottom: 32px;
}

.stat-card {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 252, 255, 0.95) 100%);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
  }

  &.bylaws::before {
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  }

  &.official::before {
    background: linear-gradient(90deg, #4CAF50 0%, #388E3C 100%);
  }

  &.access::before {
    background: linear-gradient(90deg, #FF9800 0%, #F57C00 100%);
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 8px 24px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 1);
  }
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .bylaws & { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
  .official & { background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%); }
  .access & { background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%); }
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 4px;

  .bylaws & { color: #667eea; }
  .official & { color: #4CAF50; }
  .access & { color: #FF9800; }
}

.stat-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Documents Section */
.documents-section {
  margin-top: 8px;
}

/* Tree Card */
.tree-card {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 252, 255, 0.95) 100%);
  border-radius: 20px;
  padding: 24px;
  height: 100%;
  box-shadow:
    0 6px 20px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
}

.tree-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.tree-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.tree-content {
  max-height: 500px;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(102, 126, 234, 0.05);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;

    &:hover {
      background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
    }
  }
}

.modern-treeview {
  ::v-deep .v-treeview-node__root {
    padding: 8px 12px;
    border-radius: 10px;
    margin-bottom: 4px;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(102, 126, 234, 0.05);
    }
  }

  ::v-deep .v-treeview-node__label {
    font-size: 14px;
    font-weight: 500;
    color: #475569;
  }

  ::v-deep .v-treeview-node--active {
    background: rgba(102, 126, 234, 0.1) !important;

    .v-treeview-node__label {
      color: #667eea;
      font-weight: 600;
    }
  }
}

/* Preview Card */
.preview-card {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(248, 252, 255, 0.95) 100%);
  border-radius: 20px;
  padding: 24px;
  min-height: 500px;
  box-shadow:
    0 6px 20px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.9);
}

.preview-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
}

.preview-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.preview-content {
  min-height: 400px;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.empty-title {
  font-size: 22px;
  font-weight: 700;
  color: #64748b;
  margin: 20px 0 8px;
}

.empty-text {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}

/* Selected Documents */
.selected-documents {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.document-item {
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(248, 252, 255, 0.9) 100%);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 1);
  border: 1px solid rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #f44336 0%, #d32f2f 100%);
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 8px 20px rgba(0, 0, 0, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 1);
  }
}

.document-icon {
  width: 64px;
  height: 64px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 6px 16px rgba(244, 67, 54, 0.3);
}

.document-info {
  flex: 1;
}

.document-name {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;
}

.document-link {
  ::v-deep a {
    display: inline-flex;
    align-items: center;
    padding: 10px 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    text-decoration: none;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
    }
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .documents-container {
    padding: 20px 12px;
  }

  .page-header {
    padding: 16px 18px;
  }

  .header-icon-wrapper {
    width: 42px;
    height: 42px;
  }

  .page-title {
    font-size: 20px;
  }

  .page-subtitle {
    font-size: 13px;
  }

  .hero-banner {
    border-radius: 20px;
  }

  .hero-image {
    height: 250px !important;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 15px;
  }

  .stat-card {
    padding: 16px;
  }

  .stat-icon {
    width: 48px;
    height: 48px;
  }

  .stat-value {
    font-size: 20px;
  }

  .stat-label {
    font-size: 11px;
  }

  .tree-card,
  .preview-card {
    padding: 20px;
  }

  .tree-title,
  .preview-title {
    font-size: 18px;
  }

  .document-item {
    padding: 16px;
  }

  .document-icon {
    width: 56px;
    height: 56px;
  }

  .document-name {
    font-size: 16px;
  }
}

@media (max-width: 600px) {
  .documents-container {
    padding: 16px 10px;
  }

  .page-header {
    padding: 14px 16px;
  }

  .header-icon-wrapper {
    width: 40px;
    height: 40px;
  }

  .header-icon-wrapper .v-icon {
    font-size: 26px !important;
  }

  .page-title {
    font-size: 18px;
    flex-wrap: wrap;
  }

  .page-title .v-icon {
    font-size: 22px !important;
  }

  .page-subtitle {
    font-size: 12px;
  }

  .hero-banner {
    border-radius: 16px;
  }

  .hero-image {
    height: 200px !important;
  }

  .hero-content {
    padding: 16px;
  }

  .hero-content .v-icon {
    font-size: 44px !important;
  }

  .hero-title {
    font-size: 24px;
  }

  .hero-subtitle {
    font-size: 14px;
  }

  .stat-card {
    padding: 14px;
    flex-direction: column;
    text-align: center;
  }

  .stat-icon {
    width: 44px;
    height: 44px;
  }

  .stat-icon .v-icon {
    font-size: 24px !important;
  }

  .stat-value {
    font-size: 18px;
  }

  .stat-label {
    font-size: 10px;
  }

  .tree-card,
  .preview-card {
    padding: 18px;
  }

  .tree-title,
  .preview-title {
    font-size: 17px;
  }

  .tree-content {
    max-height: 300px;
  }

  .preview-card {
    min-height: 300px;
  }

  .preview-content {
    min-height: 250px;
  }

  .empty-state {
    padding: 40px 16px;
  }

  .empty-state .v-icon {
    font-size: 64px !important;
  }

  .empty-title {
    font-size: 18px;
  }

  .empty-text {
    font-size: 13px;
  }

  .document-item {
    padding: 14px;
    flex-direction: column;
    text-align: center;
  }

  .document-icon {
    width: 52px;
    height: 52px;
  }

  .document-icon .v-icon {
    font-size: 28px !important;
  }

  .document-name {
    font-size: 15px;
  }

  .document-link ::v-deep a {
    font-size: 13px;
    padding: 8px 16px;
  }
}
</style>
